import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
	SelectSeatDepartContext,
	SelectSeatReturnContext,
	InsuranceAddonContext,
	HealthCareAddOnContext,
} from '../UserContext';
import { BusFareSummary } from './BusFareSummary';
// import { PrivateHireFareSummary } from './PrivateHireFareSummary';

import './ProceedBusFare.css';
import { sessionStorageGetItem, safeJsonParse } from './Function';
import axios from 'axios';

export const ProceedBusFare = ({ page }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const data_depart = searchParams.get('depart');
	const data_destination = searchParams.get('destination');
	const data_depart_date = searchParams.get('depart_date');
	const data_return_date = searchParams.get('return_date');
	const data_passenger = searchParams.get('passenger');
	const [shuttleTrip, setShuttleTrip] = useState();

	const { insuranceAddOn, setInsuranceAddOn } = useContext(
		InsuranceAddonContext
	);

	const { healthCareAddOn, setHealthCareAddOn } = useContext(
		HealthCareAddOnContext
	);

	let { selectedDepartSeat, setDepartSeat } = useContext(
		SelectSeatDepartContext
	);
	let { selectedReturnSeat, setReturnSeat } = useContext(
		SelectSeatReturnContext
	);

	const noOfPax = Number(searchParams.get('passenger') || 1);

	// const origin_data = JSON.parse(sessionStorageGetItem('Origin_data'));
	// const destination_data = JSON.parse(sessionStorageGetItem('Destination_data'));

	const origin_data = safeJsonParse(sessionStorageGetItem("Origin_data"), null);
	const destination_data = safeJsonParse(sessionStorageGetItem("Destination_data"), null);


	if (page === "checkout") {
		selectedDepartSeat = safeJsonParse(sessionStorageGetItem("selectedDepartSeat"), []);
		selectedReturnSeat = safeJsonParse(sessionStorageGetItem("selectedReturnSeat"), []);
	} else {
		// just in case contexts are null/undefined
		selectedDepartSeat = Array.isArray(selectedDepartSeat) ? selectedDepartSeat : [];
		selectedReturnSeat = Array.isArray(selectedReturnSeat) ? selectedReturnSeat : [];
	}


	const departData = safeJsonParse(sessionStorageGetItem("departData"), null);
	const returnData = safeJsonParse(sessionStorageGetItem("returnData"), null);
	// const depart_data_multi_modal = safeJsonParse(sessionStorageGetItem("departDataMultiModal"), null);

	// const departData = JSON.parse(sessionStorageGetItem('departData'));
	// const returnData = JSON.parse(sessionStorageGetItem('returnData'));
	// const depart_data_multi_modal = JSON.parse(sessionStorageGetItem('departDataMultiModal'));

	// ✅ Guard must be BEFORE JSX return
	if (!origin_data || !destination_data) {
		return (
			<div className="bus_fare_return">
				<div className="text-muted">Loading trip details…</div>
			</div>
		);
	}



	// useEffect(() => {
	// 	const getPrivateHire = async (tripKey) => {
	// 		const token = JSON.parse(sessionStorageGetItem('token'));

	// 		try {
	// 			const response = await axios.get(
	// 				`${process.env.REACT_APP_SERVER_URL}/Trip/get-by-trip-key/${tripKey}`,
	// 				{
	// 					headers: {
	// 						Authorization: `Bearer ${token}`,
	// 					},
	// 				}
	// 			);

	// 			if (response.data.privatehiretripid) {
	// 				const res = await axios.get(
	// 					`https://privatehire-api.causewaylink.com.my/api/trips/${response.data.privatehiretripid}`
	// 				);

	// 				setShuttleTrip(res.data);
	// 			}
	// 		} catch (error) {
	// 			console.log(error);
	// 			setShuttleTrip(undefined);
	// 		}
	// 	};

	// 	if (depart_data_multi_modal) {
	// 		getPrivateHire(depart_data_multi_modal.TripKey);
	// 	}
	// }, []);

	return (
		<>
			{/* {shuttleTrip && (
				<>
					<h1>Shuttle Bus</h1>
					<div className='bus_fare_return'>
						<PrivateHireFareSummary
							depart_data_multi_modal={shuttleTrip}
							passenger={selectedDepartSeat.length}
						/>
					</div>
				</>
			)} */}

			<h1>Bus Fare</h1>
			<div className='bus_fare_return'>
				<BusFareSummary
					include='depart'
					depart_unique_name={origin_data.subplaceuniqueshortname}
					destination_unique_name={destination_data.subplaceuniqueshortname}
					depart={origin_data.subplacedisplayname}
					selectedSeat={selectedDepartSeat}
					destination={destination_data.subplacedisplayname}
					depart_date={
						data_depart_date != null ? data_depart_date : origin_data.DepartDate
					}
					return_date={
						data_return_date != null ? data_return_date : origin_data.ReturnDate
					}
					passenger={
						data_passenger != null ? data_passenger : origin_data.Passenger
					}
					depart_info={departData}
					change_trip='/pickDepart'
					shuttleTrip={shuttleTrip}
				/>
			</div>
			{returnData != null ? (
				<div className='bus_fare_return'>
					<BusFareSummary
						include='return'
						depart_unique_name={origin_data.subplaceuniqueshortname}
						destination_unique_name={destination_data.subplaceuniqueshortname}
						depart={origin_data.subplacedisplayname}
						selectedSeat={selectedReturnSeat}
						destination={destination_data.subplacedisplayname}
						depart_date={
							data_depart_date != null
								? data_depart_date
								: origin_data.DepartDate
						}
						return_date={
							data_return_date != null
								? data_return_date
								: origin_data.ReturnDate
						}
						passenger={
							data_passenger != null ? data_passenger : origin_data.Passenger
						}
						depart_info={departData}
						return_info={returnData}
						change_trip='/pickReturn'
					/>
				</div>
			) : (
				''
			)}
		</>
	);
};
